if(typeof __WEBPACK_EXTERNAL_MODULE__0e96__ === 'undefined') {var e = new Error("Cannot find module 'leaflet-boundary-canvas'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE__0e96__;